import img11 from '../images/aboutus/1/content1.png';
import img12 from '../images/aboutus/1/content2.png';
import img13 from '../images/aboutus/1/content3.png';

import img111 from '../images/aboutus/1/m_sevice1.png';
import img112 from '../images/aboutus/1/m_sevice2.png';
import img113 from '../images/aboutus/1/m_sevice3.png';
import img114 from '../images/aboutus/1/m_sevice4.png';
import img115 from '../images/aboutus/1/m_sevice5.png';

import img121 from '../images/aboutus/1/m_dev.png';

import img21 from '../images/aboutus/2/content1.png';
import img25 from '../images/aboutus/2/content5.png';
import img22 from '../images/aboutus/2/content2.png';
import img23 from '../images/aboutus/2/content3.png';
import img24 from '../images/aboutus/2/content4.png';

import img221 from '../images/aboutus/2/m_content1.png';
import img222 from '../images/aboutus/2/m_content2.png';
import img223 from '../images/aboutus/2/m_content3.png';
import img224 from '../images/aboutus/2/m_content4.png';
import img225 from '../images/aboutus/2/m_content5.png';


import img31 from '../images/aboutus/3/content.png';
import img311 from '../images/aboutus/3/m_content1.png';
import img312 from '../images/aboutus/3/m_content2.png';
import img41 from '../images/aboutus/4/content1.png';
import img42 from '../images/aboutus/4/content2.png';
import img411 from '../images/aboutus/4/m_content1.png';
import img412 from '../images/aboutus/4/m_content2.png';
const dataSubBanner = [
    {
        id: 1,  
        titleClass: 'title1',
        pageTitle: "汽车后市场服务提供商",
        pageSubTitle: "",
        pageDetail: "",

        imgList: [img11, img12],
        mcontent: [
            {
                title: "服务闭环",
                msubtitle: "",
                mimgList: [img111, img112, img113, img114, img115],
            },
            {
                title: "发展历程",
                msubtitle: "发展是不断探索、不断创新的过程，是推动我们不断向前进步的源泉",
                contentList: [{
                    time: "2015",
                    title: "盛大启幕",
                    fazhan: ["完成了126个区域服务商签约", "建立了全国第一家自营门店"]
                },
                    {
                        time: "2016",
                        title: "继往开来",
                        fazhan: ["完成了175个区域服务商签约", "建立了2家自营门店"]
                    },
                    {
                        time: "2017",
                        title: "共享求新",
                        fazhan: ["完成213个区域服务商签约，部分省份已经能下沉至县级市完成区域服务商签约"]
                    },
                    {
                        time: "2018",
                        title: "质创辉煌",
                        fazhan: ["德联车护虹桥总部乔迁仪式圆满礼成"]
                    },
                    {
                        time: "2019",
                        title: "推陈出新",
                        fazhan: ["德联车护首家钣喷中心入驻昆明"]
                    },
                    {
                        time: "2020",
                        title: "求稳拓新",
                        fazhan: ["与民生银行电子支付部门开始合作"]
                    },
                    {
                        time: "2021",
                        title: "精诚合作",
                        fazhan: ["深耕德联民生金融项目，解决服务商资金流问题"]
                    },
                    {
                        time: "2022",
                        title: "变革之年",
                        fazhan: ["终端门店4943家，服务商310家"]
                    },
                    {
                        time: "2023",
                        title: "奋进之年",
                        fazhan: ["活跃终端门店5870家，服务商326家"]
                    },
                    {
                        time: "2024",
                        title: "冲刺之年",
                        fazhan: ["推出品牌共建计划"]
                    },
                    {
                        time: "2025",
                        title: "质变之年",
                        fazhan: ["砥砺前行，共创未来"]
                    }
                ],
            }
        ], 
        title: "上海德联车护网络发展有限公司",
        subtitle: "上海德联车护网络发展有限公司成立于2015年，是广东德联集团股份有限公司（以下简称“德联集团”）的全资子公司。",
        img: img13,
        content: ["德联集团创建于1984年，总部位于广东佛山，主营业务涵盖汽车精细化学品制造、汽车销售服务、汽车维修保养三大模块。2012年3月27日广东德联集团股份有限公司在深交所挂牌上市，股票简称：德联集团，股票代码：002666。",
        "公司旗下有30家子公司，六个大型生产基地，分别位于长春、上海、佛山、成都、青岛、蓬莱，是集生产、研发、销售、贸易、物流为一体的大型集团综合体。集团始终贯彻“品质领航，服务领先”的方针，以“节能减排、低碳环保”为经营理念，并在技术开发、销售渠道、管理体系等方面实现高效整合，致力成为汽车精细化学品的民族领导品牌，为汽车行业全产业链提供优质服务。"]

    }, 
    {
        id: 2,
        titleClass: 'title2',
        pageTitle: "IT服务",
        pageSubTitle: "服务介绍",
        pageDetail:"IT服务可以帮助汽车门店实现信息化管理，包括销售管理、库存管理、工单管理、客户关系管理等。这有助于减少手工操作，提高工作效率，并使各方面的数据更加准确可靠。并且可以收集并分析门店的各种数据，比如销售数据、库存数据、客户数据等。这些数据可以帮助门店管理层更好地理解业务状况，进行科学的决策。",
        imgList: [img21, img25, img22, img23, img24],
        mimgList: [img221, img222, img223, img224, img225]
    }    ,
    {
        id: 3,
        titleClass: 'title3',
        pageTitle: "金融支持服务",
        pageSubTitle: "服务介绍",
        pageDetail: "德联车护联合支付公司为服务商和经销门店提供高效、便捷的聚合支付通道，满足多样化的支付需求，确保交易过程顺畅无阻。协助服务商通过多渠道申请采购贷款，实现货款的即时支付，确保采购流程不受资金限制。",
        imgList: [img31],
        mimgList: [img311,img312 ]
    }    ,
    {
        id: 4,
        titleClass: 'title4',
        pageTitle: "增值服务",
        pageSubTitle: "",
        pageDetail: "德联致力于为服务商和经销门店，提供抖音引流和新能源汽车技术培训的增值服务。抖音引流可以将潜在客户挖掘出来，抖音精准的用户画像，可以增加客户转化率，这样可以使经销商和经销门店获得更多的潜在客户。德联联合东莞市汽车技术学校，使经销商和经销门店在校学习新能源汽车相关技术，提高服务商和经销门店的实际操作能力和解决实际问题的能力，服务商和经销门店可以更好地了解新能源汽车的技术和应用。",

        imgList: [img41, img42] ,
        mimgList: [img411, img412]
    }
]

export default dataSubBanner;